import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import DeleteLinkCriteria from 'use-case/link/delete/deleteLinkCriteria';
import DeleteLinkClient from 'use-case/link/delete/deleteLinkClient';

const deleteLinkApiClient = (httpClient: httpClientFunction, baseUrl: string): DeleteLinkClient => (criteria: DeleteLinkCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/links/${criteria.id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => (response.ok ? right(mapDeletedLink(criteria.id)) : left({ error: new Error(), status: response.status })))
        .catch(() => left({ error: new Error(), status: 503 }));

const mapDeletedLink = (id: string) => ({
    message: `Link ${id} deleted`,
});

export default deleteLinkApiClient;
